export default function header() {

  let scrolled;
  let lastScrollTop = 0;
  const delta = 5;
  const navbarHeight = 182;
  
  $(window).scroll(function(event){
    scrolled = true;
  });
  
  // Check condition every 250ms
  setInterval(function() {
    if (scrolled) {
      hasScrolled();
      scrolled = false;
    }
  }, 150);
  
  function hasScrolled() {
      let st = $(window).scrollTop();
      
      // Make sure they scroll more than delta => fix Safari scenario
      if (Math.abs(lastScrollTop - st) <= delta)
          return;
      
      if (st > lastScrollTop && st > navbarHeight){
        // Scroll Down
        $('.header').addClass('nav-up');
      } else {
        // Scroll Up
        if(st + $(window).height() < $(document).height()) {
            $('.header').removeClass('nav-up');
        }
    }
      
      lastScrollTop = st;
  }

  function closeMobileNav() {
    $('.nav-primary').removeClass('active');
    $('.sub-menu').removeClass('opened');
    $('body').removeClass('hidden');
    $('.overlay').removeClass('active');
    $('.burger').removeClass('burger__active')
  }

  function openMobileNav() {
    $('.nav-primary').addClass('active');
    $('body').addClass('hidden');
    $('.overlay').addClass('active');
    $('.burger').addClass('burger__active')
  }

  $('.overlay').click(function() {
    closeMobileNav();
    $('.overlay').removeClass('active');
    $('body').css({'overflow': 'auto', 'height': 'auto'});
  });
  if ($(window).width() <= 1024) {
    
    $('.nav > .menu-item-has-children').click(function() {
      $(this).children('.sub-menu').toggle('opened');
      $(this).toggleClass('expanded');
    })
    $('.nav > .menu-item-has-children > a').click(function(e) {
      e.stopPropagation();
    })
    
    $('.burger-wrapper').click(function() {
      if( $('.nav-primary').hasClass('active')){
        closeMobileNav();
      }else{
        openMobileNav();
      }
    })
  }

}


// WEBPACK FOOTER //
// ./scripts/modules/header.js